import React from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import moment from 'moment';
import * as _ from 'lodash';
import Immutable from 'seamless-immutable';
import * as staffActions from '../actions/staff';
import clientService from '../services/client';
import NotificationBanner from './boxes/NotificationBanner';
import FreezeBanner from './boxes/FreezeBanner';
import Modal from './boxes/Modal';
import EditEmployeeForm from './forms/EditEmployeeForm';
import LoadingScreen from './LoadingScreen';
import PageHeader from './boxes/PageHeader';
import PageBody from './boxes/PageBody';
import MainContent from './boxes/MainContent';
import PageNotFound from './PageNotFound';
import USER_STUB from '../user_stub.jpeg';
import {
    getDaysToCoverEnd,
    getPaymentFrequency,
    getCoverWarningType
} from './InvoiceDetailsComponent';
import { useTranslation, withTranslation } from 'react-i18next';
import { appConfig } from '../config/appConfig';

class EmployeeDetailComponent extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            plans: [],
            openUpdateProfileModal: false,
            openDeleteEmployeeModal: false
        };
    }

    componentDidMount() {
        this.getStaffDetails();
        clientService.getAllPlans().then((plans) => {
            this.setState({
                plans: plans
            });
        });
    }

    getStaffDetails() {
        const { dispatch, match, user } = this.props;
        this.clearEmployeeNotification();
        dispatch(
            staffActions.getClientEmployeeById(
                match.params.staffId,
                user.credentials.accessToken,
                user.companyInfo.id
            )
        );
    }

    toggleEmployeeModal = () => {
        this.setState({
            openUpdateProfileModal: !this.state.openUpdateProfileModal
        });
        this.clearEmployeeNotification();
    };

    toggleDeleteEmployeeModal = () => {
        this.setState({
            openDeleteEmployeeModal: !this.state.openDeleteEmployeeModal
        });
    };

    clearEmployeeNotification = () => {
        this.props.dispatch(staffActions.clearNotification());
    };

    renderLoading() {
        return (
            <MainContent>
                <PageBody>
                    <LoadingScreen />
                </PageBody>
            </MainContent>
        );
    }

    onFormSubmit = (values, dispatch) => {
        this.toggleEmployeeModal();
        dispatch(
            staffActions.editClientEmployee(
                values.user_id,
                values.first_name,
                values.last_name,
                values.email_address,
                values.phone_number,
                values.access_token,
                values.client_id
            )
        );
    };

    removeEnrollee = () => {
        if (!!this.props.selectedStaff?.is_frozen) return;
        this.toggleDeleteEmployeeModal();
        const { user, match, dispatch } = this.props;
        dispatch(
            staffActions.removeEnrolleeById(
                match.params.staffId,
                user.credentials.accessToken,
                user.companyInfo.id
            )
        );
    };

    render() {
        const { openUpdateProfileModal, openDeleteEmployeeModal, plans } = this.state;

        let { isFetching, selectedStaff, error, alert, user, invoice, t } = this.props;
        const daysToCoverEnd = getDaysToCoverEnd(invoice?.end_date);
        const isFrozen = !!selectedStaff.is_frozen;

        if (error && error.code === 404) return <PageNotFound />;

        if (!isFetching && !_.isEmpty(selectedStaff))
            return (
                <MainContent>
                    {openUpdateProfileModal && (
                        <EditEmployeeModal
                            onFormSubmit={this.onFormSubmit}
                            onClose={this.toggleEmployeeModal}
                            plans={plans}
                            user={selectedStaff}
                            clientId={user.companyInfo.id}
                            accessToken={user.credentials.accessToken}
                        />
                    )}

                    {openDeleteEmployeeModal && (
                        <DeleteEmployeeModal
                            onDeleteEmployee={this.removeEnrollee}
                            onClose={this.toggleDeleteEmployeeModal}
                            fullName={`${selectedStaff.first_name} ${selectedStaff.last_name}`}
                            isFrozen={isFrozen}
                        />
                    )}

                    <PageHeader
                        title={
                            t("employees.employeeDetailsPageTitle", {
                                firstName: selectedStaff.first_name,
                                lastName: selectedStaff.last_name
                            })
                        }
                    />
                    <PageBody>
                        {isFrozen && <FreezeBanner />}
                        {selectedStaff.isDeleted && (
                            <div className="deleted-profile__info">{t("employees.employeeDeletedInfo")}</div>
                        )}
                        <div className="button-header">
                            {user.companyInfo.canModify && (
                                <button
                                    className="primary_button"
                                    style={{ background: '#b32727' }}
                                    onClick={this.toggleDeleteEmployeeModal}
                                    disabled={isFrozen}
                                >
                                    <i className="fa fa-trash" style={{ color: 'white' }} />
                                    {'  '}
                                    {t("employees.removeEnrolleeButtonText")}
                                </button>
                            )}
                        </div>
                        {(!_.isEmpty(error) || alert) && (
                            <NotificationBanner
                                title={
                                    error.message 
                                    ? t("employees.notificationBannerErrorTitle") 
                                    : t("employees.notificationBannerDefaultTitle")
                                }
                                message={error.message ? error.message : alert}
                                type={error.message ? 'error' : 'success'}
                                close={this.clearEmployeeNotification}
                            />
                        )}
                        {selectedStaff.active_status_id === 2 && (
                            <NotificationBanner
                                title={t("employees.inactiveEmployeeNotificationTitle")}
                                message={t("employees.inactiveEmployeeNotificationMessage")}
                                type="user_details_warning"
                            />
                        )}
                        <div style={{ paddingLeft: '25px' }}>
                            <button
                                onClick={() => {}}
                                className="employee-list-btn"
                                style={{
                                    cursor: 'pointer',
                                    background: 'white',
                                    border: '1px solid rgb(222, 222, 222)'
                                }}
                            >
                                <Link
                                    style={{
                                        textDecoration: 'none',
                                        color: 'black',
                                        display: 'flex',
                                        gap: '5px',
                                        alignItems: 'center'
                                    }}
                                    to={`/dashboard/staff`}
                                >
                                    <i className="fa fa-chevron-left"></i>
                                    {t("common.back")}
                                </Link>
                            </button>
                        </div>
                        <div className="backdrop"></div>
                        <div className="dashboard_profile_enrollee">
                            <div style={{ width: '100%', textAlign: 'center' }}>
                                <img
                                    src={
                                        selectedStaff.profile
                                            ? selectedStaff.profile.picture
                                            : USER_STUB
                                    }
                                    className="profile__img"
                                    alt={t("employees.enrolleeImageAltText")}
                                />
                            </div>
                            <div
                                style={{
                                    width: '100%'
                                }}
                            >
                                <div style={{ width: '100%', margin: '10px 0' }}>
                                    <p className="enrollee-profile-section-title">
                                        {t("employees.personalInformationEnrolleeProfileSectionTitle")}
                                    </p>
                                    <div className="enrollee-data-container">
                                        <p className="enrollee-profile-section-subtitle">
                                            {t("employees.fullNameInfo")}
                                        </p>
                                        <p className="">{`${selectedStaff.first_name} ${selectedStaff.last_name}`}</p>
                                    </div>
                                </div>
                                <div style={{ width: '100%', margin: '10px 0' }}>
                                    <p className="enrollee-profile-section-title">{t("employees.planInformationEnrolleeProfileSectionTitle")}</p>
                                    <div
                                        className="enrollee-data-container"
                                        style={{ flexDirection: 'column' }}
                                    >
                                        <div className="enrollee-row">
                                            <p className="enrollee-profile-section-subtitle">
                                                {t("employees.planInfo")}
                                            </p>
                                            <p className="">{selectedStaff.product.name}</p>
                                        </div>
                                        <div className="enrollee-row">
                                            <p className="enrollee-profile-section-subtitle">
                                                {t("employees.beneficiariesInfo")}
                                            </p>
                                            <p className="">N/A</p>
                                        </div>
                                        <div className="enrollee-row">
                                            <p className="enrollee-profile-section-subtitle">
                                                {t("employees.validityInfo")}
                                            </p>
                                            <p className="">
                                                {t("common.date", {
                                                        date: selectedStaff.cover_end_date,
                                                        formatParams: {
                                                            date: {
                                                                weekday: 'long',
                                                                year: 'numeric',
                                                                month: 'long',
                                                                day: 'numeric',
                                                            },
                                                        }
                                                    })}
                                            </p>
                                        </div>
                                    </div>
                                </div>
                                <div style={{ width: '100%', margin: '10px 0' }}>
                                    <p className="enrollee-profile-section-title">
                                        {t("employees.contactInformationEnrolleeProfileSectionTitle")}
                                    </p>
                                    <div
                                        className="enrollee-data-container"
                                        style={{ flexDirection: 'column' }}
                                    >
                                        <div className="enrollee-row">
                                            <p className="enrollee-profile-section-subtitle">
                                                {t("employees.phoneNumberInfo")}
                                            </p>
                                            <p className="">{selectedStaff.phone_number}</p>
                                        </div>
                                        <div className="enrollee-row">
                                            <p className="enrollee-profile-section-subtitle">
                                                {t("employees.emailInfo")}
                                            </p>
                                            <p className="">{selectedStaff.email_address}</p>
                                        </div>
                                    </div>
                                </div>
                                {/* product requested the "update profile" button be taken out completely for all employees(employees with complete and incomplete profiles) */}

                                {/* <div>
                                    {!selectedStaff.profile && (
                                        <button
                                            className="edit-profile-button"
                                            onClick={this.toggleEmployeeModal}
                                        >
                                            {t("employees.updateInfoButtonText")}
                                        </button>
                                    )}
                                </div> */}
                                {plans.length > 0 && selectedStaff.new_product && (
                                    <p
                                        style={{
                                            padding: '20px',
                                            fontSize: '1.4em',
                                            color: 'grey'
                                        }}
                                    >
                                        <span
                                            style={{ color: '#449802', textTransform: 'uppercase' }}
                                        >
                                            {selectedStaff.new_product.name}
                                        </span>{' '}
                                        {t("employees.planBegin")}
                                    </p>
                                )}
                            </div>
                            <br />
                        </div>
                    </PageBody>
                </MainContent>
            );
        return this.renderLoading();
    }
}

const EditEmployeeModal = (props) => {
    const { t } = useTranslation();
    return (
        <Modal title={t("employees.editEmployeeDetailsModalTitle")} onClose={props.onClose}>
            <EditEmployeeForm
                onSubmit={props.onFormSubmit}
                accessToken={props.accessToken}
                clientId={props.clientId}
                plans={props.plans}
                user={props.user}
            />
        </Modal>
    );
};

const DeleteEmployeeModal = ({ fullName, onDeleteEmployee, onClose, isFrozen }) => {
    const { t } = useTranslation();
    return (
        <Modal title={t("employees.deleteEmployeeModalTitle")} onClose={onClose}>
            {isFrozen && <FreezeBanner />}
            <div className="delete-enrollee-modal">
                <p>{t("employees.deleteEmployeeConfirmationQuestion", { fullName })}</p>
                <div className="button-wrapper">
                    <button className="yes" onClick={onDeleteEmployee} style={{textTransform: "uppercase"}} disabled={isFrozen}>
                        {t("common.yes")}
                    </button>
                    <button className="no" onClick={onClose} style={{textTransform: "uppercase"}}>
                        {t("common.no")}
                    </button>
                </div>
            </div>
        </Modal>
    );
};

const mapStateToProps = ({ staff }) => ({
    selectedStaff: staff.selectedEmployee ? Immutable.asMutable(staff.selectedEmployee) : {},
    isFetching: staff.isFetching,
    error: staff.error ? Immutable.asMutable(staff.error) : {},
    alert: staff.alert
});

const EmployeeDetailComponentWithTranslation = withTranslation()(EmployeeDetailComponent);
export default connect(mapStateToProps)(EmployeeDetailComponentWithTranslation);
